import { CIcon } from '~/icons/types'

export const ciTag: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22 10.59 12.71 1.3A1 1 0 0 0 12 1H2a1 1 0 0 0-1 1v10a1 1 0 0 0 .3.71L10.59 22a3.42 3.42 0 0 0 4.83 0L22 15.42a3.42 3.42 0 0 0 0-4.83ZM7 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'tag',
  type: 'solid'
}
